import { render, staticRenderFns } from "./LoadingCloneModal.vue?vue&type=template&id=38b148a2&"
import script from "./LoadingCloneModal.vue?vue&type=script&lang=ts&"
export * from "./LoadingCloneModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports